import React from "react";
import { Tabs } from 'antd';
import LabTaskList from "../components/lab-latex/LabTaskList";
import LabStorageTankList from "../components/lab-latex/LabStorageTankList";
import { LAB_ORDER_TYPE } from "../constants/string";

export default function LabConcentrateQCView() {

  const items = [
    {
      key: 'ถาดงาน',
      label: 'การ์ดงานเข้า',
      children: <LabTaskList type={LAB_ORDER_TYPE.TANK}/>,
    },
    {
      key: 'tank',
      label: 'แทงก์',
      children: <LabStorageTankList/>,
    },
  ];

  return(
    <div style={{ marginTop : 20}}>
      <Tabs
        destroyInactiveTabPane
        defaultActiveKey="task" 
        items={items} 
      />

    </div>
  )
}